import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowUp } from 'lucide-react';
import * as React from 'react';
import { Button } from '@airia/ui';
import { Textarea } from '../../ui/textarea';
const UserChatInput = ({ onMessageSend, onChange, value, sendButtonDisabled, }) => {
    const textareaRef = React.useRef(null);
    const formRef = React.useRef(null);
    React.useEffect(() => {
        if (textareaRef.current) {
            // Reset height to auto to get the correct scrollHeight
            textareaRef.current.style.height = 'auto';
            // Set height to scrollHeight, but cap at 25vh
            const maxHeight = window.innerHeight * 0.25;
            const scrollHeight = textareaRef.current.scrollHeight;
            textareaRef.current.style.height = Math.min(scrollHeight, maxHeight) + 'px';
        }
    }, []);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (e.shiftKey) {
                // Shift+Enter: allow new line (default behavior)
                return;
            }
            else {
                // Enter: send message
                e.preventDefault();
                if (!sendButtonDisabled && value.trim() && formRef.current) {
                    // Trigger form submission
                    formRef.current.requestSubmit();
                }
            }
        }
    };
    return (_jsx("form", { ref: formRef, onSubmit: (e) => !sendButtonDisabled && onMessageSend(e), children: _jsxs("div", { className: "flex items-end justify-between p-4 border-t bg-card gap-2", children: [_jsx(Textarea, { ref: textareaRef, placeholder: "Ask Airia...", value: value, onChange: (e) => onChange(e.target.value), onKeyDown: handleKeyDown, className: "flex-1 border-none resize-none focus-visible:ring-0 focus-visible:outline-none min-h-[40px] max-h-[25vh] overflow-y-auto", style: { wordWrap: 'break-word', whiteSpace: 'pre-wrap' }, rows: 1 }), _jsx(Button, { disabled: sendButtonDisabled, size: 'icon', type: 'submit', className: 'rounded-full size-10 min-w-10 flex-shrink-0', children: _jsx(ArrowUp, { className: 'size-4' }) })] }) }));
};
export default UserChatInput;
